export default __webpack_public_path__ + "static/media/Toirdealbach's Seal.4dfda6f0.jpg";